/**
 * @fileoverview wsdot-commercial-vehicle-restrictions API - Core fetch functions and types only
 *
 * This module provides exports for fetch functions and types only (no React hooks).
 * Use this for backend/server-side code to avoid React Query dependencies.
 */

export * from "./cvRestrictionData/commercialVehicleRestrictions";
export * from "./cvRestrictionData/shared/cvRestrictionData.input";
export * from "./cvRestrictionData/shared/cvRestrictionData.output";
export * from "./cvRestrictionDataWithId/commercialVehicleRestrictionsWithId";
export * from "./cvRestrictionDataWithId/shared/cvRestrictionDataWithId.input";
export * from "./cvRestrictionDataWithId/shared/cvRestrictionDataWithId.output";
